<template>
  <div>
    <el-form
        class="detail-form-content"
        ref="ruleForm"
        :model="ruleForm"
        label-width="80px"
        style="background: transparent;"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item v-if="flag=='yonghu'" label="账号" prop="zhanghao">
            <el-input v-model="ruleForm.zhanghao" readonly placeholder="账号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='yonghu'" label="姓名" prop="xingming">
            <el-input v-model="ruleForm.xingming" placeholder="姓名" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='yonghu'" label="性别" prop="xingbie">
            <el-select v-model="ruleForm.xingbie" placeholder="请选择性别">
              <el-option
                  v-for="(item,index) in yonghuxingbieOptions"
                  v-bind:key="index"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='yonghu'" label="邮箱" prop="youxiang">
            <el-input v-model="ruleForm.youxiang" placeholder="邮箱" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='yonghu'" label="手机号码" prop="shoujihaoma">
            <el-input v-model="ruleForm.shoujihaoma" placeholder="手机号码" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="flag=='yonghu'" label="相片" prop="xiangpian">
            <file-upload
                tip="点击上传相片"
                action="file/upload"
                :limit="3"
                :multiple="true"
                :fileUrls="ruleForm.xiangpian?ruleForm.xiangpian:''"
                @change="yonghuxiangpianUploadChange"
            ></file-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='cehuashi'" label="策划账号" prop="cehuazhanghao">
            <el-input v-model="ruleForm.cehuazhanghao" readonly placeholder="策划账号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='cehuashi'" label="策划姓名" prop="cehuaxingming">
            <el-input v-model="ruleForm.cehuaxingming" placeholder="策划姓名" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='cehuashi'" label="性别" prop="xingbie">
            <el-select v-model="ruleForm.xingbie" placeholder="请选择性别">
              <el-option
                  v-for="(item,index) in cehuashixingbieOptions"
                  v-bind:key="index"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='cehuashi'" label="邮箱" prop="youxiang">
            <el-input v-model="ruleForm.youxiang" placeholder="邮箱" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="flag=='cehuashi'" label="联系手机" prop="lianxishouji">
            <el-input v-model="ruleForm.lianxishouji" placeholder="联系手机" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="flag=='cehuashi'" label="相片" prop="xiangpian">
            <file-upload
                tip="点击上传相片"
                action="file/upload"
                :limit="3"
                :multiple="true"
                :fileUrls="ruleForm.xiangpian?ruleForm.xiangpian:''"
                @change="cehuashixiangpianUploadChange"
            ></file-upload>
          </el-form-item>
        </el-col>
        <el-form-item v-if="flag=='users'" label="用户名" prop="username">
          <el-input v-model="ruleForm.username"
                    placeholder="用户名"></el-input>
        </el-form-item>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="onUpdateHandler">修 改</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import {isEmail, isMobile} from "@/utils/validate";

export default {
  data() {
    return {
      ruleForm: {},
      flag: '',
      usersFlag: false,
      yonghuxingbieOptions: [],
      cehuashixingbieOptions: [],
    };
  },
  mounted() {
    var table = this.$storage.get("sessionTable");
    this.flag = table;
    this.$http({
      url: `${this.$storage.get("sessionTable")}/session`,
      method: "get"
    }).then(({data}) => {
      if (data && data.code === 0) {
        this.ruleForm = data.data;
      } else {
        this.$message.error(data.msg);
      }
    });
    this.yonghuxingbieOptions = "男,女".split(',')
    this.cehuashixingbieOptions = "男,女".split(',')
  },
  methods: {
    yonghuxiangpianUploadChange(fileUrls) {
      this.ruleForm.xiangpian = fileUrls;
    },
    cehuashixiangpianUploadChange(fileUrls) {
      this.ruleForm.xiangpian = fileUrls;
    },
    onUpdateHandler() {
      if ((!this.ruleForm.zhanghao) && 'yonghu' == this.flag) {
        this.$message.error('账号不能为空');
        return
      }
      if ((!this.ruleForm.mima) && 'yonghu' == this.flag) {
        this.$message.error('密码不能为空');
        return
      }
      if ((!this.ruleForm.xingming) && 'yonghu' == this.flag) {
        this.$message.error('姓名不能为空');
        return
      }
      if ('yonghu' == this.flag && this.ruleForm.youxiang && (!isEmail(this.ruleForm.youxiang))) {
        this.$message.error(`邮箱应输入邮箱格式`);
        return
      }
      if ('yonghu' == this.flag && this.ruleForm.shoujihaoma && (!isMobile(this.ruleForm.shoujihaoma))) {
        this.$message.error(`手机号码应输入手机格式`);
        return
      }
      if (this.ruleForm.xiangpian != null) {
        this.ruleForm.xiangpian = this.ruleForm.xiangpian.replace(new RegExp(this.$base.url, "g"), "");
      }
      if ((!this.ruleForm.cehuazhanghao) && 'cehuashi' == this.flag) {
        this.$message.error('策划账号不能为空');
        return
      }
      if ((!this.ruleForm.mima) && 'cehuashi' == this.flag) {
        this.$message.error('密码不能为空');
        return
      }
      if ((!this.ruleForm.cehuaxingming) && 'cehuashi' == this.flag) {
        this.$message.error('策划姓名不能为空');
        return
      }
      if ('cehuashi' == this.flag && this.ruleForm.youxiang && (!isEmail(this.ruleForm.youxiang))) {
        this.$message.error(`邮箱应输入邮箱格式`);
        return
      }
      if ('cehuashi' == this.flag && this.ruleForm.lianxishouji && (!isMobile(this.ruleForm.lianxishouji))) {
        this.$message.error(`联系手机应输入手机格式`);
        return
      }
      if (this.ruleForm.xiangpian != null) {
        this.ruleForm.xiangpian = this.ruleForm.xiangpian.replace(new RegExp(this.$base.url, "g"), "");
      }
      if ('users' == this.flag && this.ruleForm.username.trim().length < 1) {
        this.$message.error(`用户名不能为空`);
        return
      }
      this.$http({
        url: `${this.$storage.get("sessionTable")}/update`,
        method: "post",
        data: this.ruleForm
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.$message({
            message: "修改信息成功",
            type: "success",
            duration: 1500,
            onClose: () => {
            }
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
